var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMydecorOrganizer = function SvgMydecorOrganizer(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1112_5284",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 110,
    height: 110
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1112_5284)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 101.02,
    r: 22.449,
    fill: "#F2F5FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.6531,
    cy: 47.1428,
    r: 5.61224,
    fill: "#FFE85F"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_5284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3768 93.201L81.8269 83.3383C82.1979 83.1594 82.6302 83.1594 83.0013 83.3383L102.501 92.7426C103.52 93.2342 103.52 94.6859 102.501 95.1775L82.0811 105.026C81.7106 105.204 81.2789 105.205 80.9082 105.026L61.3782 95.6367C60.3576 95.146 60.3567 93.693 61.3768 93.201Z",
    fill: "url(#paint0_linear_1112_5284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0811 98.2341L97.9843 90.5643L83.0013 83.3383C82.6303 83.1594 82.1979 83.1594 81.827 83.3383L65.9004 91.0194L80.9083 98.2348C81.2789 98.4131 81.7106 98.4128 82.0811 98.2341Z",
    fill: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0811 98.2341L97.9843 90.5643L83.0013 83.3383C82.6303 83.1594 82.1979 83.1594 81.827 83.3383L65.9004 91.0194L80.9083 98.2348C81.2789 98.4131 81.7106 98.4128 82.0811 98.2341Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3768 83.2028L81.8269 73.3401C82.1979 73.1611 82.6302 73.1611 83.0013 73.3401L102.501 82.7443C103.52 83.2359 103.52 84.6877 102.501 85.1793L82.0811 95.0273C81.7106 95.206 81.2789 95.2063 80.9082 95.0281L61.3782 85.6385C60.3576 85.1477 60.3567 83.6947 61.3768 83.2028Z",
    fill: "url(#paint1_linear_1112_5284)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0846 87.9741L97.7163 80.4352L83.0047 73.3401C82.6337 73.1611 82.2014 73.1611 81.8304 73.3401L66.1757 80.8901L80.9118 87.9748C81.2824 88.153 81.7141 88.1528 82.0846 87.9741Z",
    fill: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0846 87.9741L97.7163 80.4352L83.0047 73.3401C82.6337 73.1611 82.2014 73.1611 81.8304 73.3401L66.1757 80.8901L80.9118 87.9748C81.2824 88.153 81.7141 88.1528 82.0846 87.9741Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3768 73.2045L81.8269 63.3418C82.1979 63.1629 82.6302 63.1629 83.0013 63.3418L102.501 72.7461C103.52 73.2377 103.52 74.6895 102.501 75.1811L82.0811 85.029C81.7106 85.2077 81.2789 85.208 80.9082 85.0298L61.3782 75.6402C60.3576 75.1495 60.3567 73.6965 61.3768 73.2045Z",
    fill: "url(#paint2_linear_1112_5284)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1112_5284",
    x1: 103.265,
    y1: 83.2041,
    x2: 60.6122,
    y2: 83.2041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FF6D90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1112_5284",
    x1: 103.265,
    y1: 73.2059,
    x2: 60.6122,
    y2: 73.2059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FF6D90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D74"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1112_5284",
    x1: 103.265,
    y1: 63.2076,
    x2: 60.6122,
    y2: 63.2076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#FF6D90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D74"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_5284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.6531,
    height: 42.6531,
    fill: "white",
    transform: "translate(60.6122 62.8572)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMydecorOrganizer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mydecor-organizer.554a370411f9df9649a1ed5f0ea2b7ec.svg";